// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

/*
	Search icons here
	https://fontawesome.com/icons?d=gallery&s=regular,solid&m=free
*/

// import your icons
import {
	faSignInAlt,
	faSignOutAlt,
	faUserPlus,
	faUser
} from '@fortawesome/free-solid-svg-icons';

import {

} from '@fortawesome/free-regular-svg-icons';

import {

} from '@fortawesome/free-brands-svg-icons';

// add icons in library
library.add(
	faSignInAlt,
	faSignOutAlt,
	faUserPlus,
	faUser
);